module.exports = __webpack_public_path__ + "static/icons/person-5-6.f8851b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nps/person-5-6.svg
// module id = 4VpN
// module chunks = 1